import { render } from "./MarkdownEditor.vue?vue&type=template&id=9c43244e&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"

import "./MarkdownEditor.vue?vue&type=style&index=0&id=9c43244e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c43244e"]])

export default __exports__